<template>
    <!-- single item under user -->
    <div>
        <!-- if the user requests the selling page -->
        <template v-if="selling">
            <div class="row">
                <template v-if="!item.active">
                    <div class="col-12">
                        <router-link :to="{ name: 'modify-item', params: { id: item._id } }">
                            <span class="btn btn-outline-danger btn-sm form-control">
                                <i class="fas fa-eye-slash"></i> <span class="hide-on-mobile">HIDDEN</span>
                            </span>
                        </router-link>
                    </div>
                </template>
                <template v-else-if="!item.sold">
                    <div class="col-12">
                        <div class="dropdown">
                            <button class="btn btn-light-green btn-sm form-control dropdown-toggle" type="button" 
                                id="itemOptions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="hide-on-mobile">Item </span>Menu
                            </button>
                            <div class="dropdown-menu" aria-labelledby="itemOptions">
                                <router-link :to="{ name: 'modify-item', params: { id: item._id } }" class="dropdown-item" type="button">Edit Item</router-link>
                                <button class="dropdown-item" @click.prevent="showPromotion = true" type="button">Promote Item</button>
                                <button class="dropdown-item" @click.prevent="showMarkAsSold = true" type="button">Mark as Sold</button>
                                <button class="dropdown-item" @click.prevent="showGenPayLink = true" type="button">Payment Link</button>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="col-12">
                        <span @click="showMarkAsSold = true" class="h7 btn btn-light-green btn-sm form-control">
                            <i class="fas fa-handshake"></i> 
                            <span class="hide-on-mobile">
                                <span v-if="item.donation"> DONATED</span>
                                <span v-else> SOLD</span>
                            </span>
                        </span>
                    </div>
                </template>
            </div>
        </template>
        
        <!-- if the user requests the buying page -->
        <template v-if="buying">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <template v-if="!item.sold">
                            <div class="col-12">
                                <div class="dropdown">
                                    <button class="btn btn-light-green btn-sm form-control dropdown-toggle" type="button" 
                                        id="itemOptions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Item Menu
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="itemOptions">
                                        <router-link :to="{ name: 'thread', params: { itemId: item._id } }" class="dropdown-item" type="button">Item Messages</router-link>
                                        <button class="dropdown-item text-danger" @click.prevent="removeItem" type="button">Remove Item</button>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-12">
                                <span @click="showMarkAsSold = true" class="h7 btn btn-light-green btn-sm form-control">
                                    <i class="fas fa-handshake"></i> 
                                    <span v-if="item.soldTo === user._id"> BOUGHT</span>
                                    <span v-else> SOLD</span>
                                </span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>
        
        <!-- if the user requests the preview page -->
        <template v-if="portal">
            <div class="row">
                <template v-if="!item.sold">
                    <div class="col-12">
                        <router-link :to="{ name: 'itemId', params: { id: item._id } }" 
                            class="btn-light-green btn-sm form-control text-center">
                            <i class="fas fa-cogs fa-xs"></i> Manage Item
                        </router-link>
                    </div>
                </template>
                <template v-else>
                    <div class="col-12">
                        <span @click="showMarkAsSold = true" class="h7 btn btn-light-green btn-sm form-control">
                            <i class="fas fa-handshake"></i> 
                            <span v-if="item.donation"> DONATED</span>
                            <span v-else> SOLD</span>
                        </span>
                    </div>
                </template>
            </div>
        </template>
            

        <!-- show mark item as sold -->
        <app-mark-as-sold v-if="showMarkAsSold" :itemId="item._id"></app-mark-as-sold>
        
        <!-- show generate payment link -->
        <app-gen-pay-link v-if="showGenPayLink" :itemId="item._id"></app-gen-pay-link>

        <!-- show promotions -->
        <app-promotions :key="forceReloadKey" v-if="showPromotion" :itemId="item._id"></app-promotions>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

import MarkAsSold from '../../pages/sellingParts/MarkAsSold.vue'
import GenPayLink from '../../pages/sellingParts/GenPayLink.vue'
import Promotions from '../Promotions.vue'

export default {
    name: "UserItemBtns",
    props: ['item', 'sn', 'selling', 'buying', 'portal'],
    data() {
        return {
            showMarkAsSold: false,
            showGenPayLink: false,
            showPromotion: false,
            forceReloadKey: 0
        }
    },
    methods: {
        ...mapActions(['removeBuyingItem', 'fetchMsgThread', 'navbarCounter']),
        removeItem() {
            let itemObj = {
                itemId: this.item._id,
                userId: this.user._id
            }
            this.removeBuyingItem(itemObj)
            .then(() => {
                this.navbarCounter(dislikeObj).then(() => {}).catch((e) => {})
            })
            .catch((e) => {})
        },
        showBuyingThread(sellerId, itemId) {
            let threadObj = {
                buyerId: this.user._id,
                sellerId: sellerId,
                itemId: itemId,
                receiverId: this.user._id
            }
            this.fetchMsgThread(threadObj).then(() => {}).catch((e) => {})
            
            // redirect to allow message display via itemId
            this.$router.push({
                name: 'thread',
                params: { itemId }
            }).catch((e) => {})
        },
    },
    computed: {
        ...mapGetters(['user', 'modifyItem']),
    },
    components: {
        appMarkAsSold: MarkAsSold,
        appGenPayLink: GenPayLink,
        appPromotions: Promotions
    },
    watch: {
        modifyItem() {
            this.forceReloadKey += 1
        }
    },
    created() {
        eventBus.$on('hideGhostMode', (value) => {
            this.showMarkAsSold = value;
            this.showGenPayLink = value;
            this.showPromotion = value;
        })
    }
}
</script>